import { Badge, type BadgeVariant, IconTile } from "@design";
import { Database, FileUp, Globe, NotebookPen } from "lucide-react";
import type { ReactNode } from "react";
import { useTranslation } from "react-i18next";

const TYPE_ICON: Record<string, ReactNode> = {
  upload: <FileUp size={16} aria-hidden />,
  website: <Globe size={16} aria-hidden />,
  sharepoint: <Database size={16} aria-hidden />,
  notes: <NotebookPen size={16} aria-hidden />,
};

export function DataSourceIcon({ sourceType }: Readonly<{ sourceType: string }>) {
  return <IconTile variant="neutral">{TYPE_ICON[sourceType] ?? <Database size={16} aria-hidden />}</IconTile>;
}

const STATUS_VARIANT: Record<string, BadgeVariant> = {
  ready: "success",
  indexed: "success",
  active: "success",
  pending: "neutral",
  syncing: "info",
  indexing: "info",
  processing: "info",
  partial: "warning",
  error: "danger",
  failed: "danger",
};
const STATUSES = [
  "pending",
  "syncing",
  "indexing",
  "processing",
  "ready",
  "indexed",
  "active",
  "partial",
  "error",
  "failed",
] as const;
type Status = (typeof STATUSES)[number];

function asStatus(value: string): Status | undefined {
  return (STATUSES as readonly string[]).includes(value) ? (value as Status) : undefined;
}

export function DataSourceStatusBadge({ status }: Readonly<{ status: string }>) {
  const { t } = useTranslation("dataSources");
  const known = asStatus(status);
  return (
    <Badge variant={STATUS_VARIANT[status] ?? "neutral"} size="compact">
      {known ? t(`status.${known}`) : status}
    </Badge>
  );
}
